import { openDB } from 'idb'

export const SchemaSyncHandler = {
  sync () {
    openDB(process.env.VUE_APP_DB_NAME, process.env.VUE_APP_DB_VERSION, {
      upgrade (db) {
        db.createObjectStore(process.env.VUE_APP_STORE_NAME)
      }
    })
  }
}

export const open = openDB
